import { Row, Layout } from "@version2/ui-package";
import { pages, links } from "../../../../Consts/config";
import FooterButton from "../../General/FooterButton";

const { Footer } = Layout;

const FullScreenFooter = () => {
  return (
    <Footer className="full_screen__footer">
      <Row justify="center" className="full_screen__footer__inner">
        <FooterButton
          text="© ZekTec"
          onClick={() => window.open(links.ZEKTEC_WEBSITE, "_blank")}
          isExternal
        />
        <FooterButton page={pages.PRIVACY_POLICY_PAGE} />
        <FooterButton page={pages.TERMS_OF_SERVICE_PAGE} />
        <FooterButton page={pages.REFUND_POLICY_PAGE} />
        <FooterButton
          text="Blog"
          onClick={() => window.open(links.BLOG_WEBSITE, "_blank")}
          isExternal={true}
        />
        <FooterButton page={pages.ABOUT_PAGE} />
        <FooterButton page={pages.HELP_PAGE} />
      </Row>
    </Footer>
  );
};

export default FullScreenFooter;
